function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export const getWarehouseClass = (onWarehouseFrom, maxWarehouseDays, prefix, date) => {
  if (!maxWarehouseDays || !onWarehouseFrom) return '';

  const time = date.getTime();

  if (addDays(new Date(onWarehouseFrom), maxWarehouseDays).getTime() <= time) {
    return `${prefix}--danger`;
  }

  if (addDays(new Date(onWarehouseFrom), (maxWarehouseDays / 2)).getTime() <= time) {
    return `${prefix}--warning`;
  }

  return ''
};
